// extracted by mini-css-extract-plugin
export default {"titleWrap":"titleWrap---utWaK","title":"title---ZYj7t","fadeIcon":"fadeIcon---q5dQT"};